import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import _ from "lodash";

import Template1 from "./template1";

import InputButton from "../../../../../../components/ZUILib/InputButton";

import TextInput from "../../../../../../components/ZUILib/TextInput";

import commonUtil from "../../../../../../utils/commonUtil";

import * as defaultConst from "../../../../../../utils/clientConstant";
import EmptyGiftListIndicator from '../EmptyGiftListIndicator';
import WapFilterModal from "../../WapFilterModal";
import RegalosModalOverlay from "../../components/RegalosRecibidosContent/components/RegalosModalOverlay";
import ChatMessageModal from "../../components/RegalosRecibidosContent/components/ChatMessageModal";
import ModalPopover from "../../../../../../components/ZUILib/ModalPopover";
import Accordion from "../../components/Accordion";
import RadioButton from "../../../../../../components/ZUILib/RadioButton";
import * as giftListActions from "../../actions";
import Warning2 from "../../../../../../components/Warning2";
import Template2 from "../RegistradosContent/template2";
import GiftListCategories from "../../components/GiftListContent/GiftListCategories";
import DownloadPDFWithoutPreview from "../../../../../../components/DownloadPDFWithoutPreview";
import pdfUtil from "../../../../../../utils/PDFUtil";
import AddGiftsButton from "../../components/GiftListContent/AddGiftsButton";

const { getAllMessagesService } =
  giftListActions;

const eventTypes = [
  defaultConst.eventType.Aniversario,
  defaultConst.eventType.Cumpleanos,
  defaultConst.eventType.Despedida,
  defaultConst.eventType.Fiesta_Infantil,
  defaultConst.eventType.Fiesta_Reunion,
  defaultConst.eventType.Open_House,
  defaultConst.eventType.Others,
  defaultConst.eventType.Mascotas,
];
let state = {
  filteringParameters: [],
  searchKeyword: "",
  sortingType: "Ascending",
  searchFlag: true,
};

 const pageName = 'lista-de-regalos';


class FilterTag extends Component {
  render() {
    const { label, onRemove } = this.props;

    return (
      <div className="filter-tag">
        <span>{label}</span>
        <span
        className="remove-tag"
          onClick={onRemove}
        >
          ×
        </span>
      </div>
    );
  }
}
class RecibidosContent extends Component {
  constructor(props) {
    super(props);
    this.selectedGiftMode = "";
    this.filterCleared = false;
    this.selectedCategory = "";
    this.selectedMessageType = "";
    this.selectedBonusType = "";
    this.sortType = "";
    this.selectedMessage = "";
    this.selectedCategoryType = "";
    this.selectedBonus = "";
    this.selectedMode = "";
    this.filterType = [];
    this.state = {
      ...state,
      appliedFilters: { deliveryMode: null, category: null, message: null, bonusApplicable: null },
      originalReceivedGiftList: _.isObject(props.originalReceivedGiftList)
        ? props.originalReceivedGiftList
        : { categoryList: [], filteringParameters: [], itemsInfo: [], links: [] },
      openCategoryFilterModal: false,
      openFilterModal: false,
      openGiftModeFilterModal: false,
      openMessageFilterModal: false,
      openBonusFilterModal: false,
       seletedOption: commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.select.dropdown.label'),
       activeCategory: '',
       categoryDepartmentId: [],
        tempCategoryName: '',
        totalItems:'',
        selectedFilters: [],
        activeFilters :[],
        showButton: false,
        filteredCategory: [],
        filteredData: [],
        viewmoreClicked: false,
    };
    this.warningMessage = '';
    this.initialReceivedItems= props.initialReceivedItems || {}
  }
  searchedValue = "";

  componentWillUnmount() {
    state = this.state;
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.props.getAllMessagesService(
      this.props.eventId,
    );
  }

  componentWillReceiveProps(nextProps) {
    const nextOriginalReceivedGiftList = nextProps.originalReceivedGiftList;
    const prevOriginalReceivedGiftList = this.props.originalReceivedGiftList;
    const originalReceivedGiftListDidChange = nextOriginalReceivedGiftList !== prevOriginalReceivedGiftList;
    if (originalReceivedGiftListDidChange && _.isObject(nextOriginalReceivedGiftList)) {
      if (Number(nextOriginalReceivedGiftList.currentPage) === 1 || !_.isArray(nextOriginalReceivedGiftList.itemsInfo)) {
        this.setState({ originalReceivedGiftList: nextOriginalReceivedGiftList });
      } else {
        nextOriginalReceivedGiftList.itemsInfo = [...prevOriginalReceivedGiftList.itemsInfo, ...nextOriginalReceivedGiftList.itemsInfo];
        nextOriginalReceivedGiftList.itemsInfo = [...new Map( nextOriginalReceivedGiftList.itemsInfo.map(i => [i.purchaseItemId, i])).values()]
        this.setState({ originalReceivedGiftList: nextOriginalReceivedGiftList });
      }

      let appliedFilters = { deliveryMode: null, category: null, message: null, bonusApplicable: null };
      if (_.isArray(nextOriginalReceivedGiftList.filteringParameters)) {
        appliedFilters = nextOriginalReceivedGiftList.filteringParameters.reduce(
          (acc, { type, value }) => ({ ...acc, [type]: value }),
          appliedFilters,
        );
      }
      this.setState({ appliedFilters });
    }
  }

  showModal = () => {
    this.setState({ openGiftModeFilterModal: true });
    this.setState({ openCategoryFilterModal: true });
    this.setState({ openMessageFilterModal: true });
    this.setState({ openBonusFilterModal: true });
  };
  showFilter = () => {
    this.setState({ openFilterModal: true });
  };

  onSearchAreaKeyUp = (e) => {
    if (e.keyCode === 13) {
      // Service Call
      this.setState({
        searchKeyword: this.searchGift.getValue(),
        searchFlag: false,
      });
      this.props.handleSortAndFilter({
        searchKeyword: this.searchGift.getValue(),
        priceOrder: this.state.sortingType,
        filteringParameters: this.state.filteringParameters,
        currentPage: 1,
      });
      this.searchedValue = this.searchGift.getValue();
    }
    if (!e.target.value.length) {
      this.setState({ searchFlag: true });
      this.props.handleSortAndFilter({
        priceOrder: this.state.sortingType,
        filteringParameters: this.state.filteringParameters,
        currentPage: 1,
      });
    }
  };
  onClickSearchResult = () => {
    this.setState({
      searchKeyword: this.searchGift.getValue(),
      searchFlag: false,
    });
    this.props.handleSortAndFilter({
      searchKeyword: this.searchGift.getValue(),
      priceOrder: this.state.sortingType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    });
    this.searchedValue = this.searchGift.getValue();
  };
  clearSearch = () => {
    const searchTab = document.querySelector("#searchBoxforReceivedGifts").style
      .display;
    if (searchTab === "block") {
      document.querySelector("#searchBoxforReceivedGifts").style.display =
        "none";
    }
    this.setState({ searchKeyword: "", searchFlag: true });
    this.props.handleSortAndFilter({
      priceOrder: this.state.sortingType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    });
    document.getElementById("searchAreaForReceivedGifts").value = "";
  };

  handleFilters = (type, value, name) => {
    let fpType = "";
    let isRemove = false;
    if (type === "deliveryMode") {
      fpType = "deliveryMode";
      this.selectedGiftMode = name;
    } else if (type === "category") {
      this.selectedCategory = name;
      fpType = "category";
    } else if (type === "message") {
      fpType = "message";
      this.selectedMessageType = name;
    } else if (type === "bonusApplicable") {
      fpType = "bonusApplicable";
      this.selectedBonusType = name;
    }
    if (value === undefined) {
      isRemove = true;
    }
    this.updateFilterParams(fpType, value, isRemove);
  };
  updateFilterParams(fpType, value, isRemove) {
    const filteringParameters = this.state.filteringParameters;
    if (isRemove) {
      for (let i = 0; i < filteringParameters.length; i++) {
        if (filteringParameters[i].type === fpType) {
          filteringParameters.splice(i, 1);
        }
      }
    } else {
      const type = _.find(filteringParameters, { type: fpType });
      if (type) {
        type.value = value;
      } else {
        filteringParameters.push({ type: fpType, value });
      }
    }
    this.setState({
      filteringParameters,
    });
    this.props.selectedFilteringParameters(filteringParameters);
    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.state.sortingType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    });
    this.filterCleared = false;
    this.setState({
      openFilterModal: false,
      openGiftModeFilterModal: false,
      openCategoryFilterModal: false,
      openMessageFilterModal: false,
      openBonusFilterModal: false,
    });
  }

  hideModalForFilter = () => {
    this.setState({ openFilterModal: false });
  };
  searchArticleForReceivedGifts = () => {
    const searchTab = document.querySelector("#searchBoxforReceivedGifts").style
      .display;
    if (searchTab === "none") {
      document.querySelector("#searchBoxforReceivedGifts").style.display =
        "block";
    } else {
      document.querySelector("#searchBoxforReceivedGifts").style.display =
        "none";
    }
  };

  showGiftModeFilter = () => {
    this.setState({ openGiftModeFilterModal: true });
  };
  hideModalForGiftModeFilter = () => {
    this.setState({ openFilterModal: true });
    this.setState({ openGiftModeFilterModal: false });
  };

  showCategoryFilter = () => {
    this.setState({ openCategoryFilterModal: true });
  };
  hideModalForCategoryFilter = () => {
    this.setState({ openFilterModal: true });
    this.setState({ openCategoryFilterModal: false });
  };
  showMessageFilter = () => {
    this.setState({ openMessageFilterModal: true });
  };
  hideModalForMessageFilter = () => {
    this.setState({ openFilterModal: true });
    this.setState({ openMessageFilterModal: false });
  };
  showBonusFilter = () => {
    this.setState({ openBonusFilterModal: true });
  };
  hideModalForBonusFilter = () => {
    this.setState({ openFilterModal: true });
    this.setState({ openBonusFilterModal: false });
  };

  clearAllFilters = () => {
    this.selectedGiftMode = "";
    this.selectedCategory = "";
    this.filterCleared = true;
    this.selectedMessageType = "";
    this.selectedBonusType = "";
    this.setState({ filteringParameters: [] });
    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      currentPage: 1,
    });
  };

  priceSorting = (e) => {
    this.sortType = e.value;
    this.setState({ sortingType: this.sortType });
    this.props.sortingTypeForFilter(this.sortType);
    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      filteringParameters: _.get(this.props, 'receivedGiftList.filteringParameters'),
      currentPage: 1,
    });
    this.setState({ openFilterModal: false });
  };

  hideModalOverlay = () => {
    this.props.handleRegalosModalWapState(false,null,null);
    document.body.classList.remove('body-no-scroll');
  }

  showModalOverlay = (giftDetail, giftSection) => {
    this.props.handleRegalosModalWapState(true,giftDetail,giftSection);
  }

  onReplyMessageClick = (giftDetail, giftSection) => {
    document.body.classList.remove('body-no-scroll');
    this.props.handleChatMessageModalWapState(true);
    this.props.handleRegalosModalWapState(false,giftDetail, giftSection);
  }

handleSaveFilters = () => {
  this.setState({ 
    activeCategory: this.state.tempCategoryName,
    activeFilters: this.state.filteredData,
  }, () => {
    this.filterModal.handleHide();

    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      filteringParameters: this.state.filteringParameters,
      currentPage: 1,
    })
  });
};

handleClearFilters = () => {
  this.setState({ 
    selectedFilters: [],
    tempCategoryName: '',
    activeCategory: '',
    categoryDepartmentId: [],
    totalItems: '',
    activeFilters: [],
    filteringParameters: [],
    filteredCategory: [],
    filteredData: [],
  }, () => {
    this.filterModal.handleHide();

    this.props.handleSortAndFilter({
      searchKeyword: this.state.searchKeyword,
      priceOrder: this.sortType,
      currentPage: 1,
    })

    document.querySelectorAll('input[name="categoryFilterRecibidos"]').forEach(radio => {
      radio.checked = false;
    });
  });
};
 // category & bonus count
 //bonus
getRootLevelBonusCount = (data) =>{
  return data.totalItemsWithBonus;
}

 getRootLevelNonBonusCount = (data) =>{
  return data.totalItemsWithoutBonus;
}

//category
getItemsFromCategory = (data, selectedCategoryId) => {
  const category = data.categoryList.find(cat => cat.name === selectedCategoryId);
  return category ? category.totalItems : '0';
}
 // category & bonus count

removeFilter = (filter) => {
  if (filter.type === 'category') {
    document.querySelectorAll('input[name="categoryFilterRecibidos"]').forEach(radio => {
      radio.checked = false;
    });
  } else {
    document.querySelectorAll('input[name="bonusFilterRecibidos"]').forEach(radio => {
      radio.checked = false;
    });
  }

  const selectedFilters = this.state.selectedFilters.filter(item => item.type !== filter.type);
  const filteringParameters = this.state.filteringParameters.filter(item => item.type !== filter.type);
  
  const categoryFilter = selectedFilters.find(f => f.type === 'category');
  const bonusFilter = selectedFilters.find(f => f.type === 'bonusApplicable');

  let totalItems = '0';
  if (categoryFilter) {
    totalItems = this.getItemsFromCategory(this.props.originalReceivedGiftList, categoryFilter.name); // only category
  } else if (bonusFilter) {
    if(filteringParameters && filteringParameters.value=='1'){
      totalItems = this.getRootLevelBonusCount(this.props.originalReceivedGiftList); // only bonus
    }else{
      totalItems = this.getRootLevelNonBonusCount(this.props.originalReceivedGiftList); // only non bonus
    }
   
  } else {
    totalItems = this.props?.originalReceivedGiftList?.totalRecords ?? '0'; // no filters
  }

  this.setState({
    selectedFilters,
    filteringParameters,
    tempCategoryName: filter.type === 'category' ? '' : this.state.tempCategoryName,
    filteredCategory: filter.type === 'category' ? [] : this.state.filteredCategory,
    totalItems,
  }, () => {
    if (this.state.selectedFilters.length === 0) {
      this.setState({
        tempCategoryName: '',
        activeCategory: '',
        categoryDepartmentId: [],
        totalItems: '',
        activeFilters: [],
        filteringParameters: [],
        filteredCategory: [],
        filteredData: [],
      });

      this.props.handleSortAndFilter({
        searchKeyword: this.state.searchKeyword,
        priceOrder: this.sortType,
        currentPage: 1,
      });
    }
  });
};


handleCategoryChange = (selectedData) => {
    const categoryName = selectedData.value;
    const categoryId = selectedData.id.replace('categoryRecibidos-', '') || '';

    let filteringParameters = this.state.filteringParameters || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "category");
    if (categoryId) {
      updatedParameters.push({ "type": "category", "value": categoryId })
    }

    const selectedFilters = this.state.selectedFilters?.filter(item => item.type !== "category") || [];
    selectedFilters.push({ "type": "category", "name": categoryName })


    let filterContains = this.state.filteringParameters.find(item => item.type === "bonusApplicable")?.value || null;

    const filteredCategory = this.props.receivedGiftList.categoryList.find(
      category => category.name === categoryName
    );

    let totalItems = filteredCategory ? filteredCategory.totalItems : 0
    if (filterContains && filterContains === '0') {
      totalItems = filteredCategory.totalItemsWithoutBonus || 0
    }

    if (filterContains && filterContains === '1') {
      totalItems = filteredCategory.totalItemsWithBonus || 0
    }

    this.setState({
      tempCategoryName: categoryName,
      totalItems: totalItems,
      selectedFilters: selectedFilters,
      filteringParameters: updatedParameters,
      filteredCategory: filteredCategory,
      filteredData: selectedData.checked ? [{ type: 'category', value: categoryName }]  : [],
    });
};


  handleBonificationsChange = (selectedData) => {
    const bonificatinsName = selectedData.value;
    const bonificatinsId = selectedData.id.replace('bonificacionRecibidos-', '') || '';

    let filteringParameters = this.state.filteringParameters || [];
    const updatedParameters = filteringParameters.filter(item => item.type !== "bonusApplicable");
    if (bonificatinsId) {
      updatedParameters.push({ "type": "bonusApplicable", "value": bonificatinsId })
    }


    const selectedFilters = this.state.selectedFilters?.filter(item => item.type !== "bonusApplicable") || [];
    selectedFilters.push({ "type": "bonusApplicable", "name": bonificatinsName })


    let filterContains = this.state.selectedFilters.find(item => item.type === "category")?.name || null;

    const filteredCategory = filterContains && this.props.receivedGiftList.categoryList.find(
      category => category.name === filterContains
    ) || [];

    let totalItems = filteredCategory ? filteredCategory.totalItems : 0
    if (!_.isEmpty(filteredCategory)) {
      if (bonificatinsId === '1') {
        totalItems = filteredCategory.totalItemsWithBonus || 0
      } else {
        totalItems = filteredCategory.totalItemsWithoutBonus || 0
      }
    }

    if (_.isEmpty(filteredCategory)) {
      if (bonificatinsId === '1') {
        totalItems = this.getRootLevelBonusCount(this.props.originalReceivedGiftList)
      } else {
        totalItems = this.getRootLevelNonBonusCount(this.props.originalReceivedGiftList)
      }

    }


    this.setState({
      totalItems: totalItems,
      selectedFilters: selectedFilters,
      filteringParameters: updatedParameters,
      filteredData: selectedData.checked ? [{ "type": "bonusApplicable", "value": bonificatinsId }]  : [],
    });
  };

  handleScroll = () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = (scrollTop / docHeight) * 100;

    this.setState({
      showButton: scrollPercent > 25
    });
  }

  showMessagePopUp = (success) => {
    window.scrollTo({
      top: window.innerHeight * 0.8,
      behavior: "smooth",
    });

    if(success){
      this.warning.setMessage(
        commonUtil.getLabel(
          this.props.lables.EventAdminPage,
          "adminpage.regalosrecibidos.gift.added.success.message"
        )
      );
    } else {
      this.errorMessage.setMessage(
        commonUtil.getLabel(
          this.props.lables.EventAdminPage,
          "adminpage.regalosrecibidos.add.again.failure.message"
        )
      );
    }
  }


    handlePDFDownload = () => {
      const downloadableContent = (<DownloadPDFWithoutPreview pageName printingDate={this.props.printingDate} download>
        <Template2
          categoryInfo={this.props.categoryInfo}
          lables={this.props.lables}
          //registeredGiftList={this.state.registeredGiftList}
          //deliveryAddressInfo={this.state.deliveryAddressInfo}
          eventDate={this.props.eventDate}
          eventId={this.props.eventId}
          eventType={this.props.eventType}
          giftCount={this.props.giftCount}
        /> </DownloadPDFWithoutPreview>);
      pdfUtil.attachToDom(downloadableContent, pageName);
    }


  render() {
    const {
      itemsInfo: receivedGifts = [],
      filteringParameters,
      itemsCount: totalReceivedGifts,
      searchKeyword,
      recordsPerPage,
    } = this.state.originalReceivedGiftList;
    const { activeCategory } = this.state;
    const receivedGiftsFound = _.isArray(receivedGifts) && receivedGifts.length > 0;
    const currentBrandColors = commonUtil.getCurrentBrandColors();
    const resultsPerPage = _.isFinite(Number(recordsPerPage)) ? Number(recordsPerPage) : 0;
    const showBackToTopButton = _.isArray(receivedGifts) && receivedGifts.length >= 7;
    const clearAllFiltersButtonDisabled = Object.values(this.state.appliedFilters).every(f => _.isNil(f));

    let receivedGiftList = [];
    const { receivedItemsInfo } = this.props;
    if (!this.props.receivedGiftList) {
      return null;
    }

    const loadMoreButton = {
      id: 'nextButton',
      type: 'button',
      value: 'Cargar más productos',
      autoFocus: false,
      style: 'btnSecondarySpecial size-Full',
      iconClass: '',
      onClickHandler: () => {this.props.handleSortAndFilter({
        searchKeyword: this.searchGift.getValue(),
        priceOrder: this.state.sortingType,
        filteringParameters: this.state.filteringParameters,
        currentPage: Number(this.state.originalReceivedGiftList.currentPage) + 1,
      }), this.setState({viewmoreClicked: true})},
      cssStyle: {
        height: '48px',
        fontFamily: 'robotoRegular',
      },
    };

    const goToTopButton = {
      id: 'goToTopOfList',
      type: 'button',
      value: <img src={commonUtil.getAssetURL() + "/images/arrow_upward.svg"} style={{height: '32px'}} />,
      autoFocus: false,
      style: 'size-Full goToTopOfList',
      iconClass: '',
      onClickHandler: commonUtil.goToTop,
      cssStyle:{
        backgroundColor: `var(--500, ${this.props.activeThemeColor})`
      }
    };

    receivedGiftList =
      this.props.receivedGiftList && this.props.receivedGiftList.categoryList
        ? this.props.receivedGiftList
        : [];
    const receivedGift = receivedGiftList;
    this.filterType =
      !_.isEmpty(this.state.filteringParameters) && !this.filterCleared
        ? this.state.filteringParameters
        : null;
    if (!_.isEmpty(this.filterType)) {
      this.filterType.map((selectedFilter) => {
        if (selectedFilter.type === "message") {
          this.selectedMessage = selectedFilter;
          if (this.selectedMessage.value === "new") {
            this.selectedMessageType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.received.label"
            );
          }
          if (this.selectedMessage.value === "opened") {
            this.selectedMessageType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.notanswered.label"
            );
          }
          if (this.selectedMessage.value === "replied") {
            this.selectedMessageType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.answered.label"
            );
          }
          if (this.selectedMessage.value === "none") {
            this.selectedMessageType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.nomsg.label"
            );
          }
          if (this.selectedMessage.value === "") {
            this.selectedMessageType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.label"
            );
          }
        }
        if (selectedFilter.type === "category") {
          this.selectedCategoryType = selectedFilter;
          if (this.selectedCategoryType.value === "") {
            this.selectedCategory = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.category.dropdown"
            );
          } else if (this.selectedCategory === "") {
            // this.categoryname ? this.ownerName : _.find(this.props.recibidosCategory, { id: this.selectedCategoryType.value }).name,
            this.selectedCategory = _.find(this.props.recibidosCategory, {
              id: this.selectedCategoryType.value,
            }).name;
          }
        }
        if (selectedFilter.type === "bonusApplicable") {
          this.selectedBonus = selectedFilter;
          if (this.selectedBonus.value === "0") {
            this.selectedBonusType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.bonus.dropdown.notapplicable.label"
            );
          }
          if (this.selectedBonus.value === "1") {
            this.selectedBonusType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.bonus.dropdown.applicable.label"
            );
          }
          if (this.selectedBonus.value === "") {
            this.selectedBonusType = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.bonus.dropdown"
            );
          }
        }
        if (selectedFilter.type === "deliveryMode") {
          this.selectedMode = selectedFilter;
          if (this.selectedMode.value === "physical") {
            this.selectedGiftMode = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.mode.dropdown.physical.label"
            );
          }
          if (this.selectedMode.value === "electronic") {
            this.selectedGiftMode = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.mode.dropdown.electronic.label"
            );
          }
          if (this.selectedMode.value === "") {
            this.selectedGiftMode = commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.mode.dropdown"
            );
          }
        }
        return selectedFilter;
      });
    }

    const SearchArticleButton = {
      type: "button",
      id: "searchArticle",
      style: "mobileWhiteButton buscar-wap-button",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.search.article"
      ),
      onClickHandler: this.searchArticleForReceivedGifts,
    };

    const SortArticleButton = {
      type: 'button',
      id: 'sortArticle',
      style: 'mobileWhiteButton sort-wap-button',
      value: this.state.sortingType === 'Ascending' ? commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.lowest.wap.label'): commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosregistrados.priceSort.wap.label'),
      onClickHandler: () => {
        this.sortType = this.state.sortingType === 'Ascending' ? 'Descending' : 'Ascending'
        this.setState({ sortingType: this.sortType });
       this.props.handleSortAndFilter({
          priceOrder: this.sortType,
          searchKeyword: this.state.searchKeyword,
          filteringParameters: this.state.filteringParameters,
          currentPage: this.state.viewmoreClicked ? Number(this.state.originalReceivedGiftList.currentPage) + 1 : Number(this.state.originalReceivedGiftList.currentPage),
        })
      },
      disabled: !receivedGiftsFound,
      cssStyle: { opacity: receivedGiftsFound ? '100%' : '33%' },
      beforeIconClass: 'icon-swap',
      iconClass: 'glyphicon glyphicon-chevron-down sortIcon',
    };

    const GiftModeSelection = {
      htmlId: "GiftModeSelection",
      title: "GiftModeSelection",
      displayName: "GiftModeSelection",
      name: "GiftModeSelection",
      defaultValue: "GiftModeSelection",
      options: [
        {
          id: "modo de regalos(todos)",
          value: "",
          title: "modo de regalos(todos)",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.mode.dropdown"
          ),
          labelResourceId: "Físicos",
          defaultChecked:
            this.selectedMode.type === "deliveryMode" &&
            this.selectedMode.value === "",
        },
        {
          id: "physical",
          value: "physical",
          title: "Físicos",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.mode.dropdown.physical.label"
          ),
          labelResourceId: "Físicos",
          defaultChecked:
            this.selectedMode.type === "deliveryMode" &&
            this.selectedMode.value === "physical",
        },
        {
          id: "electronic",
          value: "electronic",
          title: "Electrónicos",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.mode.dropdown.electronic.label"
          ),
          labelResourceId: "Electrónicos",
          defaultChecked:
            this.selectedMode.type === "deliveryMode" &&
            this.selectedMode.value === "electronic",
        },
      ],
    };

    const BonusSelection = {
      htmlId: "BonusSelection",
      title: "BonusSelection",
      displayName: "BonusSelection",
      name: "BonusSelection",
      defaultValue: "BonusSelection",
      options: [
        {
          id: "giftListBonificación",
          value: "",
          title: "Bonificacion(todos)",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.bonus.dropdown"
          ),
          labelResourceId: "Bonificacion(todos)",
          defaultChecked:
            this.selectedBonus.type === "bonusApplicable" &&
            this.selectedBonus.value === "",
        },
        {
          id: "bonusApplicable",
          value: "1",
          title: "Aplica para bonificacion",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.bonus.dropdown.applicable.label"
          ),
          labelResourceId: "Aplica para bonificacion",
          defaultChecked:
            this.selectedBonus.type === "bonusApplicable" &&
            this.selectedBonus.value === "1",
        },
        {
          id: "bonusNotApplicable",
          value: "0",
          title: "No aplica para bonificacion",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.bonus.dropdown.notapplicable.label"
          ),
          labelResourceId: "No aplica para bonificacion",
          defaultChecked:
            this.selectedBonus.type === "bonusApplicable" &&
            this.selectedBonus.value === "0",
        },
      ],
    };

    const MessageSelection = {
      htmlId: "MessageSelection",
      title: "MessageSelection",
      displayName: "MessageSelection",
      name: "MessageSelection",
      defaultValue: "MessageSelection",
      options: [
        {
          id: "giftListMensajes",
          value: "",
          title: "Mensajes(todos)",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.message.dropdown.label"
          ),
          labelResourceId: "Mensajes(todos)",
          defaultChecked:
            this.selectedMessage.type === "message" &&
            this.selectedMessage.value === "",
        },
        {
          id: "Recibidos",
          value: "new",
          title: "Recibidos",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.message.dropdown.received.label"
          ),
          labelResourceId: "Recibidos",
          defaultChecked:
            this.selectedMessage.type === "message" &&
            this.selectedMessage.value === "new",
        },
        {
          id: "Respondidos",
          value: "replied",
          title: "Respondidos",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.message.dropdown.answered.label"
          ),
          labelResourceId: "Respondidos",
          defaultChecked:
            this.selectedMessage.type === "message" &&
            this.selectedMessage.value === "replied",
        },

        {
          id: "No respondidos",
          value: "opened",
          title: "No respondidos",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.message.dropdown.notanswered.label"
          ),
          labelResourceId: "No respondidos",
          defaultChecked:
            this.selectedMessage.type === "message" &&
            this.selectedMessage.value === "opened",
        },

        {
          id: "Sin mensaje",
          value: "none",
          title: "Sin mensaje",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.message.dropdown.nomsg.label"
          ),
          labelResourceId: "Sin mensaje",
          defaultChecked:
            this.selectedMessage.type === "message" &&
            this.selectedMessage.value === "none",
        },
      ],
    };

    const html = receivedGiftsFound && receivedGifts.map(giftItem => (
      <Template1
        eventId={this.props.eventId}
        giftDetail={giftItem}
        showProductDetail={this.showProductDetail}
        compareEventStatus={this.props.compareEventStatus}
        selectedProductForPreview={this.showModalOverlay}
        lables={this.props.lables}
        eventType={this.props.eventType}
        eventContractInfo={this.props.eventInfo.contractInfo}
        filterParams={this.state.filteringParameters}
      />
    ));

    // Modal-Data for filters
          const bonificacions = [
              {
                option:
                  this.props.lables &&
                  commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalosrecibidos.bonus.dropdown.applicable.label"
                  ),
                value: "1",
                disabled: false,
                selected: false,
              },
              {
                option:
                  this.props.lables &&
                  commonUtil.getLabel(
                    this.props.lables.EventAdminPage,
                    "adminpage.regalosrecibidos.bonus.dropdown.notapplicable.label"
                  ),
                value: "0",
                disabled: false,
                selected: false,
              },
            ]
    let accordianFilterData = [
      {
        title: 'Categories',
        content: (
          <div className="category-radio-group">
            {this.props.receivedGiftList?.categoryList?.map((ele, idx) => (
              ele.name ? (
              <div key={idx} className="radio-label-wrapper">
                <span>{ele.name}</span>
                <RadioButton
                  id={`categoryRecibidos-${ele.id}`}
                  name="categoryFilterRecibidos"
                  value={ele.name}
                  displayName=""
                  radioCssClass="radio op-0"
                  checked={this.state.tempCategoryName === ele.name}
                  onChangeFunction={this.handleCategoryChange}
                />
              </div>) : null
            ))}
          </div>

        ),
        showOnLoad: true,
      },
    ];
    if(this.props.eventType !== defaultConst.eventType.Others) {
      accordianFilterData.push({
        title: 'Bonificación',
        content: (
          <div className="category-radio-group">
            {bonificacions?.map((ele, idx) => (
              <div key={idx} className="radio-label-wrapper">
                <span>
                  {ele.option}
                  {
                    ele.value === '1' ? (
                      <span className="tag-count">({this.state.filteredCategory?.totalItemsWithBonus ?? this.props.originalReceivedGiftList?.totalItemsWithBonus})</span>
                    ) :
                      (
                        <span className="tag-count">({this.state.filteredCategory?.totalItemsWithoutBonus ?? this.props.originalReceivedGiftList?.totalItemsWithoutBonus})</span>
                      )
                  }
                </span>
                <RadioButton
                  id={`bonificacionRecibidos-${ele.value}`}
                  name="bonusFilterRecibidos"
                  value={ele.option}
                  displayName=""
                  radioCssClass="radio op-0"
                  checked={this.state.filteringParameters.find(item => item.type === "bonusApplicable")?.value === ele.value}
                  onChangeFunction={this.handleBonificationsChange}
                />
              </div>
            ))}
          </div>

        ),
        showOnLoad: true,
    });
  }

  const SaveButtonforFilter = {
      id:"Registradossavebtn",
      type: 'button',
      value: `Ver ${this.state.totalItems} artículos`,
      autoFocus: false,
      style: `btn customButtonGuardar ${this.state.activeFilters?.length === 0 ? 'widthFull' : ''}`,
      // cssStyle: { backgroundColor: this.props.activeThemeColor },
      themeColor: this.props.activeThemeColor || '#333',
      onClickHandler: this.handleSaveFilters,
      disabled: this.state.filteringParameters.length === 0 || (this.state.totalItems && (parseInt(this.state.totalItems)=== 0))
    };

const ClearButtonforFilter = {
      type: 'button',
      value: "Limpiar filtros",
      autoFocus: false,
      style: 'btn customButtonLimpiar',
      cssStyle: { border: `1px solid ${this.props.activeThemeColor || '#333'}`, color: this.props.activeThemeColor || '#333' },
      onClickHandler: this.handleClearFilters,
    };

    const FilterArticleButton = {
      type: 'button',
      id: 'filterArticle',
      style: 'mobileWhiteButton filter-wap-button wapFilterCount',
      value: commonUtil.getLabel(this.props.lables.EventAdminPage, "adminpage.regalosrecibidos.filter.by.label1"),
      filteredProducts: this.state.selectedFilters ? this.state.selectedFilters.length : 0,
      activeCategory: this.state.activeFilters?.length > 0,
      disabled: !receivedGiftsFound,
      cssStyle: { opacity: receivedGiftsFound ? '100%' : '33%' },
      beforeIconClass: 'icon-tune',
      onClickHandler: () => this.filterModal.handleShow(),
    };

    const FilterBackButton = {
      type: "button",
      id: "filter",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      onClickHandler: this.hideModalForFilter,
    };
    const ClearFilterButton = {
      id: "clearFilter",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilters,
    };
    const headerDataforFilters = (
      <div>
        <span className="choosenOption" style={{ display: "none" }} />
        <table className="tableFilterOptions">
          <tbody>
            <tr className="optionFilter">
              <td>
                <i className="icon-flecha_gruesa_izq" />
                <InputButton buttonAttr={FilterBackButton} />
              </td>
              <td>
                <InputButton buttonAttr={ClearFilterButton} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
    
    // Modal-Data for Gift-Mode Filter

    const GiftModeFilterBackButton = {
      type: "button",
      id: "filter",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      // iconClass: 'fa fa-angle-left',
      onClickHandler: this.hideModalForGiftModeFilter,
    };
    const GiftModeClearFilterButton = {
      id: "clearFilterforGiftMode",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilters,
    };
    const headerDataforGiftModeFilters = (
      <div>
        <span className="choosenOption" style={{ display: "none" }} />
        <table className="tableFilterOptions">
          <tbody>
            <tr className="optionFilter">
              <td>
                <i className="icon-flecha_gruesa_izq" />
                <InputButton buttonAttr={GiftModeFilterBackButton} />
              </td>
              <td>
                <InputButton buttonAttr={GiftModeClearFilterButton} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
    const modalLinkforGiftModeFilters = (
      <tr
        className="optionFilter"
        rel="category"
        onClick={() => this.setState({ openGiftModeFilterModal: true })}
      >
        <td>
          <p className="textCategory">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosregistrados.deliverymode.label"
            )}
          </p>
          <p className="sub">{this.selectedGiftMode}</p>
        </td>
        <td>
          <i className="icon-flecha_lightsvg_derecha" aria-hidden="true" />
        </td>
      </tr>
    );

    // Modal-data for CategoryFilter
    const CategoryFilterBackButton = {
      type: "button",
      id: "filter",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      // iconClass: 'fa fa-angle-left',
      onClickHandler: this.hideModalForCategoryFilter,
    };
    const CategoryClearFilterButton = {
      id: "clearFilterforCategory",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilters,
    };
    const headerDataforCategoryFilters = (
      <div>
        <span className="choosenOption" style={{ display: "none" }} />
        <table className="tableFilterOptions">
          <tbody>
            <tr className="optionFilter">
              <td>
                <i className="icon-flecha_gruesa_izq" />
                <InputButton buttonAttr={CategoryFilterBackButton} />
              </td>
              <td>
                <InputButton buttonAttr={CategoryClearFilterButton} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
    const modalLinkforCategoryFilters = (
      <tr
        className="optionFilter"
        rel="category"
        onClick={() => this.setState({ openCategoryFilterModal: true })}
      >
        <td>
          <p className="textCategory">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.category.by.label"
            )}
          </p>
          <p className="sub"> {this.selectedCategory}</p>
        </td>
        <td>
          <i className="icon-flecha_lightsvg_derecha" aria-hidden="true" />
        </td>
      </tr>
    );
    // Modal-Data for Messages
    const MessageFilterBackButton = {
      type: "button",
      id: "filter",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      // iconClass: 'fa fa-angle-left',
      onClickHandler: this.hideModalForMessageFilter,
    };
    const MessageClearFilterButton = {
      id: "clearFilterforMessage",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilters,
    };

    const headerDataforMessageFilters = (
      <div>
        <span className="choosenOption" style={{ display: "none" }} />
        <table className="tableFilterOptions">
          <tbody>
            <tr className="optionFilter">
              <td>
                <i className="icon-flecha_gruesa_izq" />
                <InputButton buttonAttr={MessageFilterBackButton} />
              </td>
              <td>
                <InputButton buttonAttr={MessageClearFilterButton} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
    const modalLinkforMessageFilters = (
      <tr
        className="optionFilter"
        rel="category"
        onClick={() => this.setState({ openMessageFilterModal: true })}
      >
        <td>
          <p className="textCategory">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.message.dropdown.label"
            )}
          </p>
          <p className="sub">{this.selectedMessageType}</p>
        </td>
        <td>
          <i className="icon-flecha_lightsvg_derecha" aria-hidden="true" />
        </td>
      </tr>
    );

    // Modal-Data for Bonus
    const BonusFilterBackButton = {
      type: "button",
      id: "filter",
      style: "filterBackButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.to.return"
      ),
      // iconClass: 'fa fa-angle-left',
      onClickHandler: this.hideModalForBonusFilter,
    };
    const BonusClearFilterButton = {
      id: "clearFilterforBonus",
      type: "button",
      style: "filterCleanButton",
      value: commonUtil.getLabel(
        this.props.lables.EventAdminPage,
        "adminpage.button.clear.filters"
      ),
      onClickHandler: this.clearAllFilters,
    };
    const headerDataforBonusFilters = (
      <div>
        <span className="choosenOption" style={{ display: "none" }} />
        <table className="tableFilterOptions">
          <tbody>
            <tr className="optionFilter">
              <td>
                <i className="icon-flecha_gruesa_izq" />
                <InputButton buttonAttr={BonusFilterBackButton} />
              </td>
              <td>
                <InputButton buttonAttr={BonusClearFilterButton} />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
    const modalLinkforBonusFilters = (
      <tr
        className="optionFilter"
        rel="category"
        onClick={() => this.setState({ openBonusFilterModal: true })}
      >
        {!this.props.compareEventStatus(this.props.eventType, eventTypes) ? (
          <React.Fragment>
            <td>
              <p className="textCategory">
                {commonUtil.getLabel(
                  this.props.lables.EventAdminPage,
                  "adminpage.regalosrecibidos.bonus.dropdown"
                )}
              </p>
              <p className="sub">{this.selectedBonusType}</p>
            </td>
            <td>
              <i className="icon-flecha_lightsvg_derecha" aria-hidden="true" />
            </td>
          </React.Fragment>
        ) : (
          ""
        )}
      </tr>
    );

    // Radio Button for Category
    const selectCategory = {
      name: "selectCategory",
      options: [
        {
          id: "giftListCategoría",
          value: "",
          title: "categorias(todas)",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.category.dropdown"
          ),
          labelResourceId: "categorias(todas)",
          defaultChecked:
            this.selectedCategoryType.type === "category" &&
            this.selectedCategoryType.value === "",
        },
      ],
    };

    // if (receivedGiftList && receivedGiftList.categoryList) {
    if (receivedGiftList && this.props.recibidosCategory) {
      const newSet = new Set();
      // receivedGiftList.categoryList.filter((category) => {
      this.props.recibidosCategory
        .filter((category) => {
          if (newSet.has(category.name)) {
            return false;
          }
          newSet.add(category.name);
          return true;
        })
        .map((category) =>
          selectCategory.options.push({
            id: category.id,
            value: category.id,
            displayName: category.name,
            defaultChecked:
              this.selectedCategoryType.type === "category" &&
              this.selectedCategoryType.value === category.id,
          })
        );
    }
    // Radio button for Sorting
    const PriceBasedSorting = {
      htmlId: "priceBasedSorting",
      title: "priceBasedSorting",
      displayName: "priceBasedSorting",
      name: "priceBasedSorting",
      options: [
        {
          id: "lowTohigh",
          value: "Ascending",
          title: "Menor precio",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.lower.price.by.label"
          ),
          labelResourceId: "Menor precio",
          defaultChecked:
            receivedGift &&
            receivedGift.priceOrder &&
            receivedGift.priceOrder === "Ascending",
        },
        {
          id: "higtToLow",
          value: "Descending",
          title: "Mayor precio",
          displayName: commonUtil.getLabel(
            this.props.lables.EventAdminPage,
            "adminpage.regalosrecibidos.best.price.by.label"
          ),
          labelResourceId: "Mayor precio",
          defaultChecked:
            receivedGift &&
            receivedGift.priceOrder &&
            receivedGift.priceOrder === "Descending",
        },
      ],
    };
    const totalRecords = receivedGift.itemsCount;
    const loadedRecordCount = receivedItemsInfo ? receivedItemsInfo.length : 0;
    const currentPage = receivedGift.currentPage;
    const sortType = this.state.sortingType;
    this.props.setTotalRecordsForType(
      "tabrecieved",
      totalRecords,
      loadedRecordCount,
      sortType,
      currentPage
    );

    return (
      <div className="container wrap">
          {
            this.props.regalosModalWap && 
            <RegalosModalOverlay 
              title={commonUtil.getLabel(this.props.lables.EventAdminPage, 'adminpage.regalosrecibidos.modal.header.wap.label')}
              onReplyMessageClick={this.onReplyMessageClick} 
              hideModalOverlay={this.hideModalOverlay} 
              giftSectionType={this.props.giftSectionType}
              selectedProduct={this.props.displaySelectedProductDetail}
              isWap={true} 
              eventId={this.props.eventId}
              lables={this.props.lables}
              compareEventStatus={this.props.compareEventStatus}
              eventType={this.props.eventType}
              filterParams={this.state.filteringParameters}
              handleMessagePDFDownload={this.props.handleMessagePDFDownload}
              sortingValue={this.state.sortingType}
              currentPage={currentPage}
              getRecievedGiftList={this.props.getRecievedGiftList}
              isMessageSectionDropDownWapOpen={this.props.isMessageSectionDropDownWapOpen}
              allMessages={this.props.allMessages}
              showMessagePopUp={this.props.showMessagePopUp}
              selectedTheme={this.props.selectedTheme}
            />
          }
        {(receivedGiftsFound || !_.isEmpty(filteringParameters) || !_.isEmpty(searchKeyword)) && (
          <div className="row">

            <div className="col-xs-12 giftList-filters giftlist-wap-filters">
              <div className="row">
                <div className="col-xs-6">
                  <InputButton buttonAttr={SearchArticleButton} />
                </div>
                <div className="col-xs-6"></div>
              </div>

              <div className="row searchProductBlockRegistered" id="searchBoxforReceivedGifts" style={{ display: "none" }}>
                <div className="col-xs-12 wrap">
                  <div className="input-group">
                    <TextInput
                      className="form-control"
                      htmlId="searchAreaForReceivedGifts"
                      placeholder={commonUtil.getLabel(
                        this.props.lables.EventAdminPage,
                        "adminpage.regalosrecibidos.search.message"
                      )}
                      required="true"
                      star=""
                      ref={(txt) => (this.searchGift = txt)}
                      onKeyUp={this.onSearchAreaKeyUp}
                    />
                    <span className="input-group-btn">
                      {this.state.searchFlag ? (
                        <button
                          className="btn btn-default"
                          type="button"
                          onClick={this.onClickSearchResult}
                        >
                          <i className="icon-zoom" />
                        </button>
                      ) : (
                        <button
                          className="btn btn-default"
                          type="button"
                          onClick={this.clearSearch}
                        >
                          <i className="iClass icon-tache2" />
                        </button>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xs-12 giftList-filters giftslist-wap-double-button-container">
              <div className="row">
                <div className="col-xs-4">
                  <InputButton buttonAttr={FilterArticleButton} activeThemeColor={this.props.activeThemeColor} />
                </div>
                {receivedGiftsFound && <div className="col-xs-8 pr-0">
                  <InputButton buttonAttr={SortArticleButton} />
                </div>}
              </div>
            </div>

          </div>
        )}

        <Warning2
          type="success"
          text={this.warningMessage}
          ref={(warning) => (this.warning = warning)}
          notSetToTop="true"
          onClose={true}
        />
        <Warning2
          type="error"
          text={this.errorMessage}
          ref={(errorMessage) => (this.errorMessage = errorMessage)}
          notSetToTop="true"
          onClose={true}
        />
        
        {receivedGiftsFound && (
          <div className="row text-right totalProductsCount">
            <div className="col-xs-12">
              <b>{receivedGifts.length} de {totalReceivedGifts}</b> productos
            </div>
          </div>
        )}
        <div className="row">
          <div className="col-xs-12 giftlist-table-bg">
            <table className="tableReceivedGifts tableRecievedgifts-one">
              {receivedGiftsFound ? (
                <tbody>{html}</tbody>
              ) : (
                <Fragment>
                  <EmptyGiftListIndicator giftList={`${this.initialReceivedItems.totalRecords == 0 ? 'received': 'received_noSearchResults'}`} style={{ margin: '2rem 0' }} />
                 {/* <div className="row text-center">
                    <div className="col-xs-12">
                      <a
                        style={{ color: currentBrandColors.primary, textDecoration: 'underline', cursor: 'pointer' }}
                        onClick={_.isNil(this.props.shareModal) ? undefined : this.props.shareModal.handleShow}
                      >
                        Compartir lista
                      </a>
                    </div>
                  </div>*/}
                </Fragment>
              )}
            </table>
          </div>
        </div>
        <div className="row text-center" style={{ marginTop: '3rem' }}>
          {receivedGifts.length < totalReceivedGifts && (
            <div className="col-xs-12" style={{ marginBottom: '1rem' }}>
              <InputButton buttonAttr={loadMoreButton} />
            </div>
          )}
          {receivedGiftsFound && (
            <Fragment>
             
              {showBackToTopButton && this.state.showButton && (
                <div className="col-xs-12">
                  <InputButton buttonAttr={goToTopButton} />
                </div>
              )}
            </Fragment>
          )}
        </div>

        <AddGiftsButton
          selectedTheme ={this.props.selectedTheme}
          lables = {this.props.lables}
          isDisable = {this.props.disableAnadirRegalos || false}
        />

        {/* Modal for filters */}
        <WapFilterModal
          open={this.state.openFilterModal}
          onCloseClick={() => this.setState({ openFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilters}
        >
          <p className="textCategory">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.filter.by.label"
            )}
            :
          </p>
          <table className="tableFilter">
            <tbody>
              {/* Modal for Gift Mode Selection */}
              {/* {modalLinkforGiftModeFilters} */}

              {/* Modal for Category Filter */}
              {modalLinkforCategoryFilters}

              {/* Modal for Message Filtering */}
              {/* {modalLinkforMessageFilters} */}

              {/* Modal for Bonus */}
              {modalLinkforBonusFilters}
            </tbody>
          </table>
          <br />
         {/*  <p className="textCategory">
            {commonUtil.getLabel(
              this.props.lables.EventAdminPage,
              "adminpage.regalosrecibidos.price.dropdown.label"
            )}
          </p>
          <table className="tableFilter">
            <tbody>
              {PriceBasedSorting.options.map((option, index) => (
                <tr key={index} className="optionFilter">
                  {" "}
                  <td className="textCategory"> {option.displayName} </td>
                  <td>
                    <div className="radio">
                      <input
                        type="radio"
                        checked={this.state.originalReceivedGiftList.priceOrder === option.value}
                        onChange={() => this.priceSorting({ value: option.value })}
                        id={`${index}-${option.value}-${option.displayName}`}
                      />
                      <label htmlFor={`${index}-${option.value}-${option.displayName}`} />
                    </div>{" "}
                  </td>{" "}
                </tr>
              ))}
            </tbody>
          </table> */}
          <input
            className="location"
            style={{ display: "none" }}
            type="text"
            defaultValue="filters"
          />
        </WapFilterModal>

        {/* Modal for Gift Mode */}
        <WapFilterModal
          open={this.state.openGiftModeFilterModal}
          onCloseClick={() => this.setState({ openGiftModeFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilters}
          nested
        >
          <table className="tableFilter">
            <tbody>
              {GiftModeSelection.options.map((option, index) => (
                <tr className="optionFilter">
                  {" "}
                  <td>
                    <p className="textCategory"> {option.displayName}</p>{" "}
                  </td>
                  <td>
                    <div className="radio" key={index}>
                      <input
                        type="radio"
                        id={`delivery-mode-${option.value}`}
                        checked={this.state.appliedFilters.deliveryMode === option.value}
                        onChange={() => this.handleFilters('deliveryMode', option.value, option.displayName)}
                      />
                      <label htmlFor={`delivery-mode-${option.value}`} />
                    </div>{" "}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </WapFilterModal>

        {/* Modal for Category */}
        <WapFilterModal
          open={this.state.openCategoryFilterModal}
          onCloseClick={() => this.setState({ openCategoryFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilters}
          nested
        >
          <table className="tableFilter">
            <tbody>
              {selectCategory.options.map((option, index) => (
                <tr className="optionFilter">
                  {" "}
                  <td>
                    <p className="textCategory"> {option.displayName}</p>{" "}
                  </td>
                  <td>
                    <div className="radio" key={index}>
                      <input
                        type="radio"
                        id={`category-${option.value}`}
                        checked={this.state.appliedFilters.category === option.value}
                        onChange={() => this.handleFilters('category', option.value, option.displayName)}
                      />
                      <label htmlFor={`category-${option.value}`} />
                    </div>{" "}
                  </td>{" "}
                </tr>
              ))}
            </tbody>
          </table>
        </WapFilterModal>

        {/* Modal for Message */}
        <WapFilterModal
          open={this.state.openMessageFilterModal}
          onCloseClick={() => this.setState({ openMessageFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilters}
          nested
        >
          <table className="tableFilter">
            <tbody>
              {MessageSelection.options.map((option, index) => (
                <tr className="optionFilter">
                  {" "}
                  <td>
                    <p className="textCategory"> {option.displayName}</p>{" "}
                  </td>
                  <td>
                    <div className="radio" key={index}>
                      <input
                        type="radio"
                        id={`message-${option.value}`}
                        checked={this.state.appliedFilters.message === option.value}
                        onChange={() => this.handleFilters('message', option.value, option.displayName)}
                      />
                      <label htmlFor={`message-${option.value}`} />
                    </div>{" "}
                  </td>{" "}
                </tr>
              ))}
            </tbody>
          </table>
        </WapFilterModal>

        {/* Modal for Bonus */}
        <WapFilterModal
          open={this.state.openBonusFilterModal}
          onCloseClick={() => this.setState({ openBonusFilterModal: false })}
          clearAllFiltersButtonDisabled={clearAllFiltersButtonDisabled}
          onClearAllFiltersButtonClick={this.clearAllFilters}
          nested
        >
          <table className="tableFilter">
            {!this.props.compareEventStatus(
              this.props.eventType,
              eventTypes
            ) ? (
              <tbody>
                {BonusSelection.options.map((option, index) => (
                  <tr className="optionFilter">
                    {" "}
                    <td>
                      <p className="textCategory"> {option.displayName}</p>{" "}
                    </td>
                    <td>
                      <div className="radio" key={index}>
                        <input
                          type="radio"
                          id={`bonus-applicable-${option.value}`}
                          checked={this.state.appliedFilters.bonusApplicable === option.value}
                          onChange={() => this.handleFilters('bonusApplicable', option.value, option.displayName)}
                        />
                        <label htmlFor={`bonus-applicable-${option.value}`} />
                      </div>{" "}
                    </td>{" "}
                  </tr>
                ))}
              </tbody>
            ) : (
              ""
            )}
          </table>
        </WapFilterModal>

        <ModalPopover
            modalId="filterModal" dismiss="false" isModal="true" isWapFull="true"
            ref={filterModal => this.filterModal = filterModal}
          >
            <div className="wrap wrapWap">
              <div className="row headOptionModal">
                <div className="col-xs-8"> <span className="titleOptionModal"> Filtrar </span></div>
                <div className="col-xs-4 text-right closeOptionModal" onClick={()=>{this.handleClearFilters()}}><img
                  src={commonUtil.getAssetURL() + "/images/close.svg"}
                  alt=""
                  className="icon_vozcliente"
                /></div>
              </div>
            {this.state.activeCategory&& (
              <div className="filter-container">
                {this.state.activeFilters?.length > 0 && this.state.selectedFilters.map((filter, idx) => (
                  <FilterTag
                    key={idx}
                    label={filter.name}
                    onRemove={() => this.removeFilter(filter)}
                  />
                ))}
              </div>
            )}
              <div className="row">
                <div className="col-xs-12">
                  <div className='row'>
                    <div className='mode_filter_change' style={{ padding: '0px 24px'}}>
                      <Accordion items={accordianFilterData} isOpenFilter={true} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12">
                <div className="filter-button-group">
                  {this.state.activeFilters.length > 0 && (
                    <InputButton 
                      buttonAttr={ClearButtonforFilter}
                    />
                  )}
                  <InputButton 
                    buttonAttr={SaveButtonforFilter}
                  />
                </div>
              </div>
            </div>
          </ModalPopover>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  allMessages: state.giftList.data.allMessagesInfo,
  eventInfo: state.giftList?.data?.eventSummaryInfo?.eventInfo || {},
});

const matchDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getAllMessagesService,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  matchDispatchToProps
)(RecibidosContent);
